import { OUTREACH_SECTION_LABELS, OUTREACH_STATE_EVENT } from '../../features/outreach/constants';
import { buildAccountingSidebarTabItems, buildTaxSidebarTabItems } from './sidebarNavConfig';
import { useEffect, useState } from 'react';
import { matchViewPath } from '../../utils/subRoutes';
import { parseWorkspaceFinancePath } from '../../utils/workspaceFinanceRoutes';
import { PURCHASES_SECTIONS } from '../../features/purchases/purchasesSections';
import { SALES_SECTIONS } from '../../features/sales/salesSections';

function currentSectionId(currentView: string | undefined): string {
  const fallback = currentView === 'outreach' ? 'approvals' : currentView === 'accounting' ? 'bank-accounts' : currentView === 'tax' ? 'vat-returns' : 'overview';
  if (typeof window === 'undefined') return fallback;
  const workspaceRoute = parseWorkspaceFinancePath(window.location.pathname);
  const route = matchViewPath(window.location.pathname);
  return (workspaceRoute && workspaceRoute.hub === currentView ? workspaceRoute.section : route && route.view === currentView ? route.slug : null) || fallback;
}

/** Reuses the hub's section definitions and existing navigation events. */
export function useHubSectionTitle(currentView: string | undefined): string | null {
  const [sectionId, setSectionId] = useState(() => currentSectionId(currentView));
  useEffect(() => {
    if (!currentView || !['sales', 'purchases', 'accounting', 'tax', 'outreach'].includes(currentView)) return;
    setSectionId(currentSectionId(currentView));
    const onSection = (event: Event) => {
      const detail = (event as CustomEvent<{ sectionId?: string; activeSection?: string }>).detail;
      const id = detail?.sectionId ?? detail?.activeSection;
      if (id) setSectionId(id);
    };
    const eventName = currentView === 'outreach' ? OUTREACH_STATE_EVENT : `${currentView}:section-change`;
    window.addEventListener(eventName, onSection);
    return () => window.removeEventListener(eventName, onSection);
  }, [currentView]);
  const sections = currentView === 'sales' ? SALES_SECTIONS : currentView === 'purchases' ? PURCHASES_SECTIONS : null;
  const financeSections = currentView === 'accounting' ? buildAccountingSidebarTabItems() : currentView === 'tax' ? buildTaxSidebarTabItems() : null;
  if (currentView === 'outreach') return OUTREACH_SECTION_LABELS[sectionId as keyof typeof OUTREACH_SECTION_LABELS] ?? null;
  return sections?.find(section => section.id === sectionId)?.label ?? financeSections?.find(section => section.id === sectionId)?.label ?? null;
}
